import { ContainerModule, interfaces } from 'inversify'
import { DY_TYPES } from '@compliance/di/serviceIdentifiers'
import { CaseViewModel } from '@compliance/modules/CaseViewModel'

export const caseViewModelModule = () =>
  new ContainerModule((bind: interfaces.Bind) => {
    bind<CaseViewModel>(DY_TYPES.CaseViewModel).to(CaseViewModel)
  })
